export default __webpack_public_path__ + "static/media/Github.fe21a633.svg";